(function () {

    class LandingPagesWizardHeader {
        constructor($state) {
            this._state = $state;
            this.editing = Boolean($state.params.pageId);
        }

        navigateToLandingPageDetails() {
            this._state.go("app.landingpages.details", this._state.params);
        }

        navigateToTemplateSetup() {
            if ('pageId' in this._state.params) {
                this._state.go("app.landingpages.template", this._state.params);
            }
        }

        navigateToPlacementDetails() {
            if ('pageId' in this._state.params) {
                this._state.go("app.landingpages.placement", this._state.params);
            }
        }
    }

    angular
        .module('dashboard')
        .component('landingPagesWizardHeader',
            {
                templateUrl: 'components/landingpages/wizard/header/landing-pages-wizard-header.acf07fe6.html',
                bindings: {
                    headerState: "=",
                },
                controller: [
                    '$state',
                    LandingPagesWizardHeader]
            });
})();
